import { ref } from "vue";
import { defineStore } from "pinia";

export const useChatStore = defineStore("chat", () => {
  const openedChatIds = ref([]);

  return { openedChatIds };
});
